import React, { useState } from "react";
import "./FaqGroup.css";
import QuestionDropDown from "./QuestionDropDown.jsx";

const FAQs = [
  {
    Q: "Can I become a celebrity using PROTAL?",
    A: "Have a  PASSION, build your PERSISTENCE and some day you might get the PODIUM",
  },
  {
    Q: "What Genres of talents Protal is covering?",
    A: "Singing, Dancing, Photography, Acting, Modelling and Art are the following domains which are covered as of now. If you have an idea about exciting domains do contact us",
  },
  {
    Q: "How can I benefit from Protal?",
    A: "Mentorship, Community Learning, Talent Network, Industry Connections, the Stage for Talents, are all available here. ",
  },
  {
    Q: "Are workshops free or paid?",
    A: "Workshops are free as well as paid",
  },
  {
    Q: "Is Protal worth joining?",
    A: "Why not join something which Enriches and Encourages your Talent? #vocalforlocal",
  },
  {
    Q: "Are there career opportunities at Protal?",
    A: "To know more about amazing career opportunities please reach us out through mail at teamprotal@gmail.com",
  },
];

const FaqGroup = () => {
  const [faqToggleArray, setToggleArray] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const handleOpen = (id) => {
    if (faqToggleArray[id] === true) {
      setToggleArray([false, false, false, false, false, false]);
      return null;
    }

    const newArray = [false, false, false, false, false, false];
    newArray[id] = true;
    setToggleArray(newArray);
  };

  return (
    <div className="faq-group-body">
      <QuestionDropDown
        id={0}
        Q={FAQs[0].Q}
        A={FAQs[0].A}
        open={faqToggleArray[0]}
        onClick={() => handleOpen(0)}
      />
      <QuestionDropDown
        id={1}
        Q={FAQs[1].Q}
        A={FAQs[1].A}
        open={faqToggleArray[1]}
        onClick={() => handleOpen(1)}
      />
      <QuestionDropDown
        id={2}
        Q={FAQs[2].Q}
        A={FAQs[2].A}
        open={faqToggleArray[2]}
        onClick={() => handleOpen(2)}
      />
      <QuestionDropDown
        id={3}
        Q={FAQs[3].Q}
        A={FAQs[3].A}
        open={faqToggleArray[3]}
        onClick={() => handleOpen(3)}
      />
      <QuestionDropDown
        id={4}
        Q={FAQs[4].Q}
        A={FAQs[4].A}
        open={faqToggleArray[4]}
        onClick={() => handleOpen(4)}
      />
      <QuestionDropDown
        id={5}
        Q={FAQs[5].Q}
        A={FAQs[5].A}
        open={faqToggleArray[5]}
        onClick={() => handleOpen(5)}
      />
    </div>
  );
};

export default FaqGroup;
